
import "/Users/hejing/codes/smart/packages/webApp/src/components/RightContent/index.less?modules";
export default {"search": `search-H99RfJpV`,"account": `account-7eA8kZ_9`,"avatar": `avatar-VtEI7VMQ`,"dark": `dark-IwUQkmy8`,"menu": `menu-onMKOXU4`,"right": `right-x91oWjzs`,"action": `action-mSOCi2Ei`}
